export function getOportunidadeIdFromUrl(): number | null {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('oportunidadeId');

  if (id && !isNaN(parseInt(id, 10))) {
    return parseInt(id, 10);
  }

  return null;
}
